import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import {
  BrokerServicePriceModalComponent,
  CustomModalComponent,
  SelfFilerModalComponent,
  SelfServicePriceModalComponent,
} from './components';

@NgModule({
  declarations: [CustomModalComponent, BrokerServicePriceModalComponent, SelfFilerModalComponent, SelfServicePriceModalComponent],
  imports: [CommonModule, TranslateModule, RouterModule],
  exports: [CustomModalComponent, BrokerServicePriceModalComponent, SelfFilerModalComponent, SelfServicePriceModalComponent],
})
export class CustomModalModule {}
